/**
 * PDF parsing has been removed. Keep this hook as a compatibility shim for
 * pages that still carry historical PDF state, but do not call a parser API.
 */
export function usePdfLvSummary() {
  return {
    pdfSummary: null,
    pdfPreviewError: null,
    pdfPreviewLoading: false,
  };
}
